import React, { useEffect } from "react";
import "./DigitalMarketing.css";

// IMAGES
import seoImg from "../../assets/images/d1.jpg";
import adsImg from "../../assets/images/d2.jpg";
import socialImg from "../../assets/images/d3.jpg";
import emailImg from "../../assets/images/d4.jpg";
import webImg from "../../assets/images/d5.jpg";


import client1 from "../../assets/images/dclient1.png";
import client2 from "../../assets/images/dclient2.png";
import client3 from "../../assets/images/dclient3.png";
import client4 from "../../assets/images/dclient4.png";
import client5 from "../../assets/images/dclient5.png";
import client6 from "../../assets/images/dclient6.png";
import client7 from "../../assets/images/dclient7.png";
import client8 from "../../assets/images/dclient8.png";
import client9 from "../../assets/images/dclient9.png";
import client10 from "../../assets/images/dclient10.png";




const DigitalMarketing = () => {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal, .dm-project");

    const revealOnScroll = () => {
      revealElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const isVisible =
          rect.top < window.innerHeight - 100 && rect.bottom > 0;

        if (isVisible) {
          el.classList.add("show");
        } else {
          el.classList.remove("show"); // repeat animation
        }
      });
    };

    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener("scroll", revealOnScroll);
  }, []);

  return (
    <>
     {/* ================= HERO SECTION ================= */}
<section className="dm-hero reveal">
  <div className="dm-wrapper">
    {/* -------- LEFT LIST -------- */}
    <div className="dm-left reveal">
      <h1 className="dm-title">Digital Marketing Services</h1>

      <ul className="dm-list reveal">
        <li>SEO Service</li>
        <li>Paid Advertisement</li>
        <li>Website Maintenance</li>
        <li>Social Media Optimization</li>
        <li>Email Marketing</li>
      </ul>
    </div>

    {/* -------- RIGHT FORM -------- */}
    <div className="dm-form-box reveal">
      <h2>Get Free Consultation</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Full Name *" required />
        <input type="email" name="email" placeholder="Email Address *" required />
        <input type="text" name="phone" placeholder="Phone Number *" required />
        <textarea name="message" placeholder="Your Requirements"></textarea>

        <button type="submit" className="dm-btn">Submit</button>
      </form>
    </div>
  </div>
</section>

      {/* ================= INFO SECTION ================= */}
      <section className="dm-info reveal">
        <div className="dm-info-container reveal">
          <h2>NMD Infotech Services</h2>

          <p>
            At NMD Infotech Services, we provide comprehensive digital marketing
            solutions designed to help businesses thrive in the digital age. Our
            services include search engine optimization (SEO), social media
            marketing, pay-per-click (PPC) advertising, content marketing, and
            email marketing — all tailored to meet the unique needs of each
            client.
          </p>

          <p>
            With a team of experienced professionals and data-driven strategies,
            we aim to boost your online presence, drive targeted traffic, and
            increase conversions.
          </p>

          <p>
            Partner with NMD Infotech Services to transform your digital
            footprint and achieve measurable results that propel your business
            forward.
          </p>
          <a href="/contact" class="no-underline">
  <button className="dm-btn center">Talk Today</button>
</a>

        </div>
      </section>

      {/* ================= CLIENT PROJECTS / CASE STUDIES ================= */}
      <section className="dm-projects">
        <div className="dm-projects-wrapper">
          {[
            {
              title: "SEO Services by NMD Infotech Services",
              desc: "Our SEO solutions are crafted to elevate your website’s visibility, driving organic traffic and enhancing your online presence. We dive deep into keyword research, on-page optimization, and quality link-building strategies to ensure your site ranks high and stays ahead of the competition.",
              img: seoImg,
            },
            {
              title: "Paid Advertisement Services by NMD Infotech Services",
              desc: "Maximize your reach with our strategic paid advertisement services. We design and manage tailored campaigns across platforms like Google Ads, social media, and display networks, ensuring your brand gets noticed by the right people at the right time. From creative ad development to budget optimization and performance tracking, every dollar is invested in delivering measurable results.",
              img: adsImg,
            },
            {
              title: "Website Maintenance Services by NMD Infotech Services",
              desc: "Your website is often the first impression of your brand. Our website maintenance services focus on keeping your digital presence robust and up-to-date. We handle everything from regular content updates and security patches to design enhancements and performance improvements, ensuring your site remains efficient, secure, and engaging for visitors 24/7.",
              img: socialImg,
            },
            {
              title: "Social Media Optimization",
              desc: "Build a dynamic online community with our social media optimization services. We help you craft compelling content, engage with your audience, and grow your following across platforms like Facebook, Instagram, LinkedIn, and more. Our tailored strategies aim to boost brand visibility, foster genuine interactions, and turn social engagement into meaningful business growth.",
              img: emailImg,
            },
            {
              title: "Email Marketing",
              desc: "Stay connected with your audience through personalized and impactful email marketing campaigns. We design and execute messages that nurture leads, drive conversions, and build customer loyalty. From sleek templates to insightful analytics, our approach ensures your message not only reaches inboxes but also resonates with your audience, turning engagement into action.",
              img: webImg,
            },
          ].map((item, index) => (
            <div
              key={index}
              className={`dm-project reveal scroll-fast ${
                index % 2 === 0 ? "left-img" : "right-img"
              }`}
            >
              <div className="dm-project-img">
                <img src={item.img} alt={item.title} />
              </div>

              <div className="dm-project-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                 {/* ⭐ Read More Button */}
          <button className="read-more-btn">Read More</button>
        </div>
      </div>
            
          ))}
        </div>
      </section>




      {/* ================= CLIENTS SECTION ================= */}
      <section className="dm-clients">
  <h2>OUR ESTEEMED CLIENTS</h2>

  {/* LEFT → RIGHT ROW */}
  <div className="client-row row-left">
    <div className="client-row-content">
      {[client1, client2, client3, client4, client5, client1, client2, client3, client4, client5].map((img, index) => (
        <div key={index} className="client-logo">
          <img src={img} alt={`Client ${index + 1}`} />
        </div>
      ))}
    </div>
  </div>

  {/* RIGHT → LEFT ROW */}
  <div className="client-row row-right">
    <div className="client-row-content">
      {[client6, client7, client8, client9, client10, client6, client7, client8, client9, client10].map((img, index) => (
        <div key={index} className="client-logo">
          <img src={img} alt={`Client ${index + 6}`} />
        </div>
      ))}
    </div>
  </div>
</section>


   {/* ================= TESTIMONIALS SECTION ================= */}
<section className="dm-testimonials">

<h2 className="ts-title">Voices of Trust and Satisfaction</h2>

<div className="ts-wrapper">

  <div className="ts-card">
    <p>
    I highly recommend NMD Infotech for their exceptional digital marketing services! Their team is highly skilled and knowledgeable in SEO, Google Ads, social media marketing, and overall digital strategies.
    </p>
    <h4>– Saurabh Jadhav</h4>
  </div>

  <div className="ts-card">
    <p>
      Nmd Infotech is the best IT service provider and business consultant.
    </p>
    <h4>– Pratik Sonkamble</h4>
  </div>

  <div className="ts-card">
    <p>
      I engaged with NMD Infotech Services for their data analytics solutions,
      and I was thoroughly impressed.
    </p>
    <h4>– Shubham B</h4>
  </div>

</div>

<div className="ts-cta">
  <h3>Talk to Our Experts Today!</h3>
  <button className="ts-btn">Talk Today</button>
</div>

</section>







    </>
  );
};

export default DigitalMarketing;
